import { getColumnServiceFocTab } from 'constants/table';
import CustomTable from '../room-available-components/CustomTable';
import { useGetServicesFoc } from 'hooks/useGetFocs';
import { GetFocsType } from 'services/api/type/report.type';
import { useEffect, useMemo } from 'react';

interface ServicesFocProps {
  isEnable: boolean;
  filterOptions: GetFocsType;
  t: (key: string) => string;
  dataSource: (record: any[]) => void;
}

export default function ServicesFocTab({
  isEnable,
  filterOptions,
  t,
  dataSource
}: ServicesFocProps) {
  const { data: servicesFoc, isLoading } = useGetServicesFoc(filterOptions, isEnable);

  const totalServicesQty =
    servicesFoc?.reduce((acc: any, room: any) => acc + room.services_qty, 0) || 0;
  const totalCalculatePrice =
    servicesFoc?.reduce((acc: any, room: any) => acc + room.calculate_price, 0) || 0;

  const formattedServicesFoc = useMemo(() => {
    return servicesFoc.map((service: any) => ({
      ...service,
      date_of_foc: !service.services ? service.date_of_foc : ''
    }));
  }, [servicesFoc]);

  const dataWithTotal = useMemo(() => {
    return [
      ...formattedServicesFoc,
      {
        booking_id: t('managePage.focsReportPage.common.total'),
        partner_name: '',
        services_qty: totalServicesQty,
        service_default_price: '',
        calculate_price: totalCalculatePrice,
        room_type: '',
        date_of_foc: ''
      }
    ];
  }, [formattedServicesFoc, t, totalServicesQty, totalCalculatePrice]);

  // For exporting: include expanded (nested) service items as individual rows.
  const exportDataWithTotal = useMemo(() => {
    const exportRows = formattedServicesFoc.flatMap((record: any) => {
      const nested = record?.services;
      if (Array.isArray(nested) && nested.length) {
        return nested.map((child: any) => ({
          ...child,
          booking_id: child?.booking_id ?? record?.booking_id,
          partner_name: child?.partner_name ?? record?.partner_name
        }));
      }
      return [record];
    });

    return [
      ...exportRows,
      {
        booking_id: t('managePage.focsReportPage.common.total'),
        partner_name: '',
        services_qty: totalServicesQty,
        service_default_price: '',
        calculate_price: totalCalculatePrice,
        room_type: '',
        date_of_foc: ''
      }
    ];
  }, [formattedServicesFoc, t, totalServicesQty, totalCalculatePrice]);

  useEffect(() => {
    if (exportDataWithTotal.length) {
      dataSource(exportDataWithTotal);
    }
  }, [exportDataWithTotal, dataSource]);

  const columnServiceFocTab = useMemo(() => {
    return getColumnServiceFocTab(t);
  }, [t]);

  return (
    <CustomTable
      rowKey="booking_id"
      loading={isLoading}
      columns={columnServiceFocTab}
      dataSource={dataWithTotal || []}
      t={t}
    />
  );
}
